import { Building, Rotate3d, UserRound, Users } from "lucide-react"
import { useForm, SubmitHandler, Control } from "react-hook-form"
import { Controller } from 'react-hook-form';
import { useAddNode } from "../utils/query";
import { useRef, useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { sleep } from "../utils/utils";
import { LabeledBtn } from "./LabeledBtn";

type Inputs = {
    type: 'person' | 'group' | 'entity' | 'effort'
    name: string
}



//TODO: Move into another file
interface TypeSelectorProps {
    control: Control<Inputs>;
    name: "name" | "type";
}


const TypeSelector: React.FC<TypeSelectorProps> = ({ control, name }) => (
    <Controller
        defaultValue={'person'}
        control={control}
        name={name}
        render={({ field }) => (
            <div className="form-control w-full max-w-xs">
                <div className="label">
                    <span className="label-text">Select type</span>
                </div>
                <div className="flex justify-center max-w-3xl mx-auto">
                    <LabeledBtn
                        icon={<UserRound />}
                        label="Person"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            field.onChange('person');
                        }}
                        className={field.value === 'person' ? 'btn-neutral' : ''}
                    />
                    <LabeledBtn
                        icon={<Users />}
                        label="Group"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            field.onChange('group');
                        }}
                        className={field.value === 'group' ? 'btn-neutral' : ''}
                    />
                    <LabeledBtn
                        icon={<Building />}
                        label="Entity"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            field.onChange('entity');
                        }}
                        className={field.value === 'entity' ? 'btn-neutral' : ''}
                    />
                    <LabeledBtn
                        icon={<Rotate3d />}
                        label="Effort"
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            e.preventDefault();
                            field.onChange('effort');
                        }}
                        className={field.value === 'effort' ? 'btn-neutral' : ''}
                    />
                </div>
                <input type="hidden" {...field} />
            </div>
        )}
    />
);

export const AddNodeDialog = () => {
    const dialogRef = useRef<HTMLDialogElement>(null)
    const queryClient = useQueryClient()

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>()

    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        console.log(data)
        await mutation.mutate({
            id: Math.random().toString(),
            circleId: "1",
            type: data.type,
            name: data.name,
            subtitle: '',
            description: '',
            tags: [],
            avatars: [],
            lastUpdated: '',
            timestamp: new Date().toISOString(),
            // add other required properties if any
        });
        //TODO: This is a hack, Figure out something else
        await sleep(100);
        await queryClient.invalidateQueries({ queryKey: ['nodes'] });
        dialogRef.current?.close()
    }

    const mutation = useAddNode();

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        const handleOpen = () => {
            console.log("Opened")
            reset();
        }

        dialog.addEventListener('close', handleOpen);
        return () => {
            dialog.removeEventListener('close', handleOpen);
        }
    }, [reset]);

    console.log(errors)
    return (
        <dialog ref={dialogRef} id="add_node" className="modal">
            <div className="modal-box roudned-md">
                <form method="dialog">
                    {/* if there is a button in form, it will close the modal */}
                    <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" onClick={() => {
                        reset();
                    }}>✕</button>
                </form>
                <form
                    className="justify-items-center mb-4 max-w-3xl mx-auto"
                    id="add-node-form"
                    onSubmit={handleSubmit(onSubmit)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSubmit(onSubmit)(e);
                        }
                    }}
                >
                    <TypeSelector control={control} name="type" />
                    <label className="form-control w-full max-w-xs">
                        <div className="label">
                            <span className="label-text">Name</span>
                        </div>
                        <input type="text" placeholder="Type here" className={`input input-bordered ${errors.name ? 'input-error' : ''} w-full max-w-xs`} {...register("name", { required: true, maxLength: 200 })} />
                        <div className="label">
                            {errors.name &&  errors.name.type === "required" && <span className="label-text text-error">This field is required</span>}
                            {errors.name &&  errors.name.type === "maxLength" && <span className="label-text text-error">This field is must be shorter than 200 characters</span>}

                        </div>
                    </label>
                </form>
                <div className="modal-action">
                    <input className="btn" type="submit" form="add-node-form" value="Add Node" />

                </div>
            </div>
        </dialog>
    )
}